import * as React from 'react';
import CallbackHelpers from '../helpers/CallbackHelpers';

export interface EngageLeaderContextProps {
  reloadDatasets: (refresh?: boolean) => void;
  reloadInstances: (refresh?: boolean) => void;
  journeyInstanceId: string;
  journeyType: string;
}

export const EngageLeaderContext = React.createContext<EngageLeaderContextProps>({
  reloadDatasets: CallbackHelpers.NoOp,
  reloadInstances: CallbackHelpers.NoOp,
  journeyInstanceId: undefined,
  journeyType: undefined
});